import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'mvs-te-test-case-result',
    templateUrl: './te-test-case-result.component.html',
    standalone: false
})
export class TeTestCaseResultComponent implements OnInit, OnChanges, OnDestroy {

  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized

  constructor() {
  }

  ngOnInit(): void {
    this.initComponent();
    this.refreshComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
